export default __webpack_public_path__ + "hitfilm-express.94740bb3.png";